import {GenericInput} from '@hm/fundamental'
import React from 'react'
import {Controller, FieldValues, Path} from 'react-hook-form'

import {handleAllowedCharacters} from '../../../common/utils/handleAllowedCharacters'
import {useTranslation} from '../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../Skeleton/UserInformationInputSkeleton'

import {UserInformationProps} from './types'

type UserEmailInputProps<T extends FieldValues> = UserInformationProps<T> & {
  canEditUserEmailPhone: boolean
  setShowMfaInput?: (show: boolean) => void
}

export const UserEmailInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  canEditUserEmailPhone,
  isLoading,
  name
}: UserEmailInputProps<T>) => {
  const {t} = useTranslation()
  const errors = formMethods.formState.errors

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  const hasError = !!errors.eMail?.message
  const localKey = `errorMessages.${errors.eMail?.message}`
  const helperText = hasError ? t(localKey) : ''

  return (
    <Controller
      name={name}
      control={formMethods.control}
      rules={{
        validate: (value) =>
          value.length === 0 && formMethods.watch('mobileNumber' as Path<T>).length === 0
            ? 'PHONE_OR_EMAIL_REQUIRED'
            : value.length > 0 && !value.includes('@')
              ? 'EMAIL_SIGN'
              : value.length > 0
                ? handleAllowedCharacters(value, 'EMAIL_FORMAT_NOT_ALLOWED')
                : true
      }}
      render={({field}) => (
        <GenericInput
          {...field}
          data-test-id={`userInformationForm-${field.name}`}
          label={t('userInformationForm.email')}
          isDisabled={!canEditUserEmailPhone}
          isReadOnly={readonlyMode}
          error={helperText}
          isTouched={true}
        />
      )}
    />
  )
}
